module.exports = __webpack_public_path__ + "img/organization_zh.b46caa40.jpg";